/*
Loons Lab Sub title component
Developed By Roshan
Loons Lab
*/
import React, { Fragment, Component } from 'react'
import { Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import * as apiroutes from '../../../../apiroutes'
import localStorageService from 'app/services/localStorageService'

let image_array = ['/assets/images/hotelimages/1.jpg',
    '/assets/images/hotelimages/2.jpg',
    '/assets/images/hotelimages/3.jpg',
    '/assets/images/hotelimages/4.jpg',
    '/assets/images/hotelimages/5.jpeg'
]

class ImageView extends Component {
    /**
     how to use
     * 
     * var data = {
     *      path: '',
     *      extension: '',
     *      
     * }
     * 
     * <ImageView image_data={data} preview_width='100px'  preview_height='100px' />
     * 
     * **/
    constructor(props) {
        super(props)
        this.state = {
            image_data: this.props.image_data,
            image_url: '',
        }
    }

    static propTypes = {
        image_data: PropTypes.object,
        preview_width: PropTypes.string,
        preview_height: PropTypes.string,
        class_Name: PropTypes.string,
    }

    static defaultProps = {
        image_data: {},
        preview_width: '300px',
        preview_height: '300px',
        class_Name: '',
        default_image_url: '/assets/images/package_default.jpg',
        //default_image_url: image_array[Math.floor(Math.random() * image_array.length)],
        backgroundView: false
    }

    async componentDidMount() {
        console.log("image data", this.state.image_data);

        const accessToken = await localStorageService.getItem('accessToken');

        if (!this.state.image_data) {
            this.setState({ image_url: this.props.default_image_url });
            return;
        }

        const { path, extension } = this.state.image_data;
        const uri = `${apiroutes.FILE_VIEW}?url=${path}&type=view&extension=${extension}`;

        try {
            const response = await fetch(uri, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });

            if (response.status === 404) {
                // Handle 404 explicitly
                console.warn("Image not found (404), setting default image.");
                this.setState({ image_url: this.props.default_image_url });
                return;
            }

            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

            const blob = await response.blob();
            const imageUrl = URL.createObjectURL(blob);

            // Cleanup previous object URL to prevent memory leaks
            if (this.state.image_url) {
                URL.revokeObjectURL(this.state.image_url);
            }

            this.setState({ image_url: imageUrl });
        } catch (err) {
            console.error("Image fetch error:", err);
            this.setState({ image_url: '/assets/images/blank-profile.png' });
            //this.setState({ image_url: image_array[Math.floor(Math.random() * image_array.length)], });
        }
    }

    render() {
        const { preview_width, preview_height, class_Name, backgroundView } = this.props

        return (
            <Fragment>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        {backgroundView ?
                            <div
                                className={class_Name}
                                style={{
                                    backgroundImage: `url(${this.state.image_url})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    width: preview_width || "100px", // Default width
                                    height: preview_height || "100px", // Default height
                                }}
                            />
                            :
                            <img
                                className={class_Name}
                                src={this.state.image_url}
                                width={preview_width}
                                height={preview_height}
                            />
                        }
                        {/* <img
                            className={class_Name}
                            src={this.state.image_url}
                            width={preview_width}
                            height={preview_height}
                        /> */}


                    </Grid>
                </Grid>
            </Fragment>
        )
    }
}

export default ImageView
